import Component from '@glimmer/component';
import type { CustomFieldSignature } from '../../../types/tuition-assistance.ts';

export interface TuitionAssistanceProgramTemplateReviewCustomRowReviewSignature {
  Args: {
    model: CustomFieldSignature;
  };
}

export default class TuitionAssistanceProgramTemplateReviewCustomRowReviewComponent extends Component<TuitionAssistanceProgramTemplateReviewCustomRowReviewSignature> {
  isTrueOrFalse(value: boolean) {
    return value ? 'Yes' : 'No';
  }

  parseInputType(input: string) {
    if (!input) {
      return 'ERROR: Missing type';
    }

    return input === 'textarea' ? 'Freeform Text' : 'Yes/No';
  }

  <template>
    <div class="col-span-6 grid grid-cols-10 gap-8 items-center my-4">
      <div class="col-span-1 justify-self-center">
        {{@model.ordinal}}
      </div>
      <div class="col-span-3">{{@model.label}}</div>
      <div class="col-span-2 pl-4">{{this.parseInputType @model.input}}</div>
      <div class="col-span-2 self-center justify-self-center">
        {{this.isTrueOrFalse @model.visible}}
      </div>
      <div class="col-span-2 self-center justify-self-center">
        {{this.isTrueOrFalse @model.required}}
      </div>
    </div>
  </template>
}
